export default __webpack_public_path__ + "static/Policy Contract_i-MedicalCard (MV)-1d6074379b02fcc56cf9221cd559680c.pdf";